import { Checkbox, Flex, theme } from "antd";
import React, { useState } from "react";

import { JOB_TYPE_FILTER_MAP } from "../constants";

import {
  JobTypeFilterOptions,
  JobTypeFilterSelect,
  JobTypeFilterSelectButton,
  StyledArrowDown,
} from "./styled";
import { JobTypeFilterProps } from "./types";

const options = JOB_TYPE_FILTER_MAP.map((value) => ({
  value: value.backend,
  label: value.frontend,
}));

export const JobTypeFilter: React.FC<JobTypeFilterProps> = ({ queryState, queryDispatch }) => {
  const { token } = theme.useToken();

  const [open, setOpen] = useState(false);

  const handleChange = (e: string[]) => {
    queryDispatch({
      type: "update_job_type",
      value: e.join(","),
    });
  };

  return (
    <JobTypeFilterSelect
      dropdownRender={() => (
        <JobTypeFilterOptions>
          <Checkbox.Group onChange={handleChange} value={queryState.jobType.split(",")}>
            <Flex vertical>
              {options.map((option, idx) => (
                <Checkbox key={idx} value={option.value}>
                  {option.label}
                </Checkbox>
              ))}
            </Flex>
          </Checkbox.Group>
        </JobTypeFilterOptions>
      )}
      open={open}
      onOpenChange={setOpen}
      placement="bottomRight"
      trigger={["click"]}
      $token={token}
    >
      <JobTypeFilterSelectButton>
        <div>
          {"Job Type "}
          {queryState.jobType && (
            <span>
              (<strong>{queryState.jobType.split(",").length}</strong>)
            </span>
          )}
        </div>
        <StyledArrowDown open={open} />
      </JobTypeFilterSelectButton>
    </JobTypeFilterSelect>
  );
};
